// extracted by mini-css-extract-plugin
module.exports = {"modal":"DobModal_modal__2xrqn","close":"DobModal_close__1VYy7","header":"DobModal_header__1MBot","button":"DobModal_button__2pKY_"};